import React, { Component } from "react";
import "../../routes/app";
import withAuthorization from "../../components/Authorization/withAuthorization";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { fire, auth } from "../../firebase/index";
import MemberManagement from "../MemberManagement/MemberManagement";
import SettingManagement from "../SettingManagement/setting";
import { Button, Modal } from "react-bootstrap";
import { customLog } from "../../variables/Variables";
// import EditProfile from "../EditProfile/EditProfile";

//import subcomponents
import { ResetPassword } from "./ResetPassword";
// import { ResetPassword } from "./ResetEmail";
import { SubscriptionManagement } from "./SubscriptionManagement";
import { RedemptionManagement } from "./RedemptionManagement";
// import EditProfile from "../EditProfile/EditProfile";
//? import chatbot
// import Chatbot from "../../views/Chatbot/Chatbot";

//CSS
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import "../../assets/css/account-management.css";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    accountManagement: "Account Management",
    editProfile: "Edit Profile",
    resetPassword: "Reset Password",
    settingheader: "Setting",
    memberManagementHeader: "Member Management",
    subscription: "Subscription",
    redemption: "Redemption",
  },
  ja: {
    accountManagement: "アカウント管理",
    editProfile: "プロファイル編集",
    resetPassword: "パスワードを再設定する",
    settingheader: "設定",
    memberManagementHeader: "メンバー管理",
    subscription: "サブスクリプション",
    redemption: "申込み",
  },
  es: {
    accountManagement: "Gestión de Cuenta",
    editProfile: "Editar Perfil",
    resetPassword: "Restablecer Contraseña",
    settingheader: "Configuración",
    memberManagementHeader: "Gestión de Miembros",
    subscription: "Suscripción",
    redemption: "Redención",
  },
});

class AccountManagement extends Component {
  constructor(props) {
    super(props);
    // this.currentpasswordChange = this.currentpasswordChange.bind(this);

    this.state = {
      isPaymentValid: false,
      isAdmin: false,
      isSuperAdmin: false,
      currentLanguage: localizationStrings.getLanguage(),
      currentPaymentType: "",
      activeRedemptionCode: "",
      isActiveCodeExist: false,
    };
  }

  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });

      const groupAccountsDB = fire.database().ref("groupAccounts");

      groupAccountsDB.once("value").then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((eachSuperAdmin) => {
            const superAdminDetails = eachSuperAdmin.val();
            // const superAdminId = eachSuperAdmin.key;
            const members = superAdminDetails.members;

            for (const eachMembers in members) {
              const memberDetails = members[eachMembers];
              if (memberDetails.memberEmail === auth.currentUser.email) {
                const paymentDetails = superAdminDetails.payment.isPaymentValid;
                this.setState({
                  isAdmin: memberDetails.isAdmin,
                  isSuperAdmin: memberDetails.isSuperAdmin,
                  isPaymentValid: paymentDetails,
                });
              }
            }
          });
          // this.setState({ isPaymentValid: snapshotVal.isPaymentValid });
        }
      });

      groupAccountsDB
        .child(auth.currentUser.uid)
        .child("payment")
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            const groupAccountPayment = snapshot.val();
            const activeRedemptionCode =
              groupAccountPayment.currentRedemptionActiveCode;

            this.setState({
              currentPaymentType: groupAccountPayment.currentPaymentType,
            });

            if (
              activeRedemptionCode !== null &&
              activeRedemptionCode !== "" &&
              activeRedemptionCode !== undefined
            ) {
              this.setState({
                activeRedemptionCode: activeRedemptionCode,
                isActiveCodeExist: true,
              });
            } else {
              customLog("User do not have an active redemption code");
            }
          }
        })
        .then(() => {
          customLog(
            "Active Redemption Code " + this.state.activeRedemptionCode
          );
          customLog("Active Code Exist " + this.state.isActiveCodeExist);
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div style={{ width: "95%", marginLeft: "auto", marginRight: "auto" }}>
        <div className="header">
          <h2>{localizationStrings.accountManagement}</h2>
        </div>
        <br />

        <Tabs forceRenderTabPanel defaultIndex={0}>
          <TabList>
            {/* <Tab>{localizationStrings.editProfile}</Tab> */}
            <Tab>{localizationStrings.resetPassword}</Tab>

            {this.state.isPaymentValid &&
            (this.state.isAdmin || this.state.isSuperAdmin) ? (
              <Tab>{localizationStrings.memberManagementHeader}</Tab>
            ) : (
              <Tab disabled hidden>
                {localizationStrings.memberManagementHeader}
              </Tab>
            )}

            {this.state.isPaymentValid &&
            this.state.isSuperAdmin &&
            (this.state.currentPaymentType == "STRIPE" ||
              this.state.currentPaymentType == "") ? (
              <Tab>{localizationStrings.subscription}</Tab>
            ) : (
              <Tab disabled hidden>
                {localizationStrings.subscription}
              </Tab>
            )}

            {this.state.isPaymentValid &&
            this.state.isSuperAdmin &&
            this.state.currentPaymentType == "REDEMPTION" ? (
              this.state.activeRedemptionCode != "" ? (
                <Tab>{localizationStrings.redemption}</Tab>
              ) : (
                <Tab disabled hidden>
                  {localizationStrings.redemption}
                </Tab>
              )
            ) : (
              <Tab disabled hidden>
                {localizationStrings.redemption}
              </Tab>
            )}

            {/* <Tab>{localizationStrings.settingheader}</Tab> */}
          </TabList>
          {/* //!todo -> EditProfile and SettingsManagement (Under devlopment stage) */}

          {/* <TabPanel>
            <EditProfile />
          </TabPanel> */}
          <TabPanel>
            <ResetPassword />
          </TabPanel>
          <TabPanel>
            <MemberManagement />
          </TabPanel>
          <TabPanel>
            <SubscriptionManagement />
          </TabPanel>
          <TabPanel>
            <RedemptionManagement />
          </TabPanel>
          {/* <TabPanel>
            <SettingManagement />
          </TabPanel> */}
        </Tabs>
        <div className="empty-space"></div>
        {/* <Chatbot/> */}
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(AccountManagement);
